import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=d03dc382&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=d03dc382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03dc382",
  null
  
)

export default component.exports